import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, Firestore } from 'firebase/firestore';

export interface ContactFormData {
    name: string;
    email: string;
    phone?: string;
    projectType?: string;
    budget?: string;
    subject: string;
    message: string;
}

export async function sendContactEmail(data: ContactFormData): Promise<{ success: boolean; message: string }> {
    try {
        // Check if Firebase is initialized
        if (!db) {
            console.error('❌ Firebase not initialized');
            return { 
                success: false, 
                message: 'Firebase not initialized. Please check your environment variables.' 
            };
        }

        // Validate required fields
        if (!data.name || !data.email || !data.subject || !data.message) {
            return { 
                success: false, 
                message: 'Please fill in all required fields.' 
            };
        }

        const firestoreDb: Firestore = db;
        // Save contact form submission to Firestore
        // A Firebase Function or backend service can then process these and send emails
        const contactData = {
            name: data.name,
            email: data.email,
            phone: data.phone || '',
            projectType: data.projectType || '',
            budget: data.budget || '',
            subject: data.subject,
            message: data.message,
            createdAt: serverTimestamp(),
            status: 'new', // Can be used to track if email was sent
        };

        const docRef = await addDoc(collection(firestoreDb, 'contact-submissions'), contactData);

        console.log('✅ Contact form submitted successfully:', docRef.id);
        
        return { 
            success: true, 
            message: 'Your message has been sent successfully. We will get back to you soon!' 
        };
    } catch (error) {
        console.error('Send Contact Email Error:', error);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        
        if (import.meta.env.DEV) {
            console.error('Error details:', errorMessage);
        }
        
        return {
            success: false,
            message: 'An error occurred while sending your message. Please try again later or contact us directly at kontakt@koricode.de',
        };
    }
}

